import type { WithClassNameProp, WithDataTestid } from '@vlabs/uikit/types';
import cn from 'classnames';

import './NavbarPanelHeader.sass';
import { buildTestid } from '../../../lib/utils';
import { useNavbarContext } from '../useNavbarContext';

export interface NavbarPanelHeaderProps extends
  WithDataTestid,
  WithClassNameProp {
  toggleButton?: React.ReactElement;
  logo?: React.ReactElement;
}

const displayName = 'NavbarPanelHeader';
const testid = buildTestid(displayName);

function NavbarPanelHeader({
  toggleButton = undefined,
  logo = undefined,
  className = undefined,
  'data-testid': dataTestId = undefined,
}: NavbarPanelHeaderProps): React.JSX.Element {
  const { type } = useNavbarContext();
  return (
    <div
      {...testid(dataTestId)}
      className={cn('NavbarPanelHeader', {
        [`NavbarPanelHeader_${type}`]: type,
        NavbarPanelHeader_withLogo: logo,
      }, className)}
    >
      {!!logo && (
        <div
          className="NavbarPanelHeader__Logo"
          {...testid('Logo', dataTestId)}
        >
          {logo}
        </div>
      )}
      {toggleButton}
    </div>
  );
}

NavbarPanelHeader.displayName = displayName;

export { NavbarPanelHeader };
